/* eslint-disable max-len */

import VeChainQuestion from 'images/coin-pages/questions/vechain.svg'

import { ICoinPageData } from '../types'

export const vetPage: ICoinPageData = {
  title: 'coin_1074',
  description: 'coin_1075',
  // description: 'coin_1076',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'VeChain' }) }} />
  ),
  questionsBlock: {
    image: VeChainQuestion,
    questions: [
      {
        title: 'coin_1077',
        answer: 'coin_1078',
      },
      {
        title: 'coin_1079',
        answer: 'coin_1080',
      },
      {
        title: 'coin_1081',
        answer: 'coin_1082',
      },
      {
        title: 'coin_1083',
        answer: 'coin_1084',
      },
    ],
  },
  whatIs: {
    text: ['coin_1087'],
    paragraphs: [
      {
        title: 'coin_1085',
        text: ['coin_1088'],
      },
      {
        title: 'coin_1086',
        text: ['coin_1089'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/vechain-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2022/05/VET-article-1.png',
        imageAlt: 'VeChain (VET) review 7',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'VeChain (VET) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'VeChain (VET) review 6',
      },
    ],
  },
}
